
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container,Spinner, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Table} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import axios from '../../axios';
import Select from 'react-select'
import { useRef } from 'react';
import moment from 'moment';
import numeral from 'numeral'
import _ from 'lodash'
import SweetAlert from "react-bootstrap-sweetalert";
import FileSaver from 'file-saver'
import Xl from 'excel4node'


import { Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display:'flex',
    flexDirection:'column',
  
  },
}));



const MonthWiseBooking=()=>{

    //buyerhelp
    const [buyerhelp,setbuyerhelp]=useState([])
    const[buyervalue,setbuyervalue]=useState({label:"All", value:"0"})

    //companyhelp
    const [companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState({})

    //tablehelp
    const [monthwisehelp, setmonthwisehelp] = useState([])



    //date
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())

    const [notfoundpopup, setnotfoundpopup] = useState(false)
    const [notfoundpopup1, setnotfoundpopup1] = useState(false)

    //view 
    const [showtable, setshowtable] = useState(false)

    const classes = useStyles();
    const [Spinner1, setSpinner1] = useState(false)

        useEffect(()=>{

            company()
            buyer()
            
          
            var date =  new Date()
          
            var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
           
            var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
            setfromdate(moment(firstday).format('YYYY-MM-DD'))
            settodate(moment(lastday).format('YYYY-MM-DD'))
            setCompanyvalue(JSON.parse(localStorage.getItem('company')))
        },[])

        const company=async()=>{
            await axios.instance.get("CompanyHelp/GetCompany")
            .then((res)=>{
    
                const data=res.data
                const option=data.map(row=>({
                    "label":row.company,
                    "value":row.companyId
                }))
                console.log(option,"companyhelp");
                setcompanyhelp(option)  
            }) 
        }

        const buyer=async()=>{
            await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
            .then((res)=>{
                const data =res.data
                const option=data.map(row=>({
                    "label":row.buyer,
                    "value":row.buyerId
                }))
                console.log(option,"buyerhelp")
                option.push({"label":"All",
                "value":"0"})
                setbuyerhelp(option)
            })
        }

        const tabledata=async()=>{
            if(new Date(fromdate) >(new Date("1900-01-01"))  && new Date(todate) >(new Date("1900-01-01"))){
            setSpinner1(true)
            setshowtable(true);
            await axios.instance.get(`/MonthWiseBooking?companyId=${Companyvalue.value}&buyerId=${buyervalue.value}&fromDate=${moment(fromdate).format('YYYY-MM-DD')}&toDate=${moment(todate).format('YYYY-MM-DD')}`)
            .then ((res)=>{
console.log(res.data,'monthwise')
                let total = [{
                    
                        "BuyerId": 141,
                        "Buyer": "Total",
                        "Year": "",
                        "Janqty":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Janqty );
                            }, 0),
                        "Janval":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Janval );
                            }, 0),
                        "Febqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Febqty );
                            }, 0),
                        "Febval":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Febval );
                            }, 0),
                        "Marqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Marqty );
                            }, 0),
                        "Marval":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Marval );
                            }, 0),
                        "Aprqty":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Aprqty );
                            }, 0),
                        "Aprval": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Aprval );
                            }, 0),
                        "Mayqty":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Mayqty );
                            }, 0), 
                        "Mayval": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Mayval );
                            }, 0),
                        "Junqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Junqty );
                            }, 0),
                        "Junval": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Junval );
                            }, 0),
                        "Julqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Julqty );
                            }, 0),
                        "Julval":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Julval );
                            }, 0),
                        "Augqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Augqty );
                            }, 0),
                        "Augval":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Augval );
                            }, 0),
                        "Sepqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Sepqty );
                            }, 0),
                        "Sepval": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Sepval );
                            }, 0),
                        "Octqty":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Octqty );
                            }, 0),
                        "Octval": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Octval );
                            }, 0),
                        "Novqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Novqty );
                            }, 0),
                        "Novval":res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Novval );
                            }, 0),
                        "Decqty": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Decqty );
                            }, 0),
                        "Decval": res.data.reduce((accumulator, object) => {
                            return accumulator + (object.Decval );
                            }, 0),
                        "Totqty": res.data.reduce((accumulator, object) => {
                            return accumulator + ((object.Janqty )+(object.Febqty )+(object.Marqty )
                            +(object.Aprqty )+(object.Mayqty )+(object.Junqty )+(object.Julqty )
                            +(object.Augqty )+(object.Sepqty )+(object.Octqty )+(object.Novqty )
                            +(object.Decqty ));
                            }, 0),
                        "Totval": res.data.reduce((accumulator, object) => {
                            return accumulator + ((object.Janval )+(object.Febval )+(object.Marval )
                            +(object.Aprval )+(object.Mayval )+(object.Junval )+(object.Julval )
                            +(object.Augval )+(object.Sepval )+(object.Octval )+(object.Novval )
                            +(object.Decval ));
                            }, 0),
                    
                }]
                res.data.length !== 0 ? setmonthwisehelp(res.data.concat(total)) : (setshowtable(false) || setnotfoundpopup(true))
                handleDownload()
            })
            
            setTimeout(() => {
                setSpinner1(false)
              }, 2000);
            }
            else{
                setnotfoundpopup1(true)
            }
        }

        const monthwiseExel = () => {

            // monthwisehelp
            let buyerName = []
            for(let data of monthwisehelp){
                buyerName.push(data.Buyer)
            }


            let jan = []
            monthwisehelp.map((data) => {
                //console.log(data,'dadada')
                jan.push({
                    'Qty':numeral(data.Janqty.toString()).format("0,0"),
                    'Value':numeral(data.Janval.toString()).format("0,0.0000")
                })
            })

            let feb = []
            monthwisehelp.map((data) => {
                // console.log(data)
                feb.push({
                    'Qty':numeral(data.Febqty.toString()).format("0,0"),
                    'Value':numeral(data.Febval.toString()).format("0,0.0000")
                })
            })

            let mar = []
            monthwisehelp.map((data) => {
                // console.log(data)
                mar.push({
                    'Qty':numeral(data.Marqty.toString()).format("0,0"),
                    'Value':numeral(data.Marval.toString()).format("0,0.0000")
                })
            })

            let apr = []
            monthwisehelp.map((data) => {
                // console.log(data)
                apr.push({
                    'Qty':numeral(data.Aprqty.toString()).format("0,0"),
                    'Value':numeral(data.Aprval.toString()).format("0,0.0000")
                })
            })

            let may = []
            monthwisehelp.map((data) => {
                // console.log(data)
                may.push({
                    'Qty':numeral(data.Mayqty.toString()).format("0,0"),
                    'Value':numeral(data.Mayval.toString()).format("0,0.0000")
                })
            })

            let jun = []
            monthwisehelp.map((data) => {
                // console.log(data)
                jun.push({
                    'Qty':numeral(data.Junqty.toString()).format("0,0"),
                    'Value':numeral(data.Junval.toString()).format("0,0.0000")
                })
            })

            let jul = []
            monthwisehelp.map((data) => {
                // console.log(data)
                jul.push({
                    'Qty':numeral(data.Julqty.toString()).format("0,0"),
                    'Value':numeral(data.Julval.toString()).format("0,0.0000")
                })
            })

            let aug = []
            monthwisehelp.map((data) => {
                // console.log(data)
                aug.push({
                    'Qty':numeral(data.Augqty.toString()).format("0,0"),
                    'Value':numeral(data.Augval.toString()).format("0,0.0000")
                })
            })

            let sep = []
            monthwisehelp.map((data) => {
                // console.log(data)
                sep.push({
                    'Qty':numeral(data.Sepqty.toString()).format("0,0"),
                    'Value':numeral(data.Sepval.toString()).format("0,0.0000")
                })
            })

            let oct = []
            monthwisehelp.map((data) => {
                // console.log(data)
                oct.push({
                    'Qty':numeral(data.Octqty.toString()).format("0,0"),
                    'Value':numeral(data.Octval.toString()).format("0,0.0000")
                })
            })

            let nov = []
            monthwisehelp.map((data) => {
                // console.log(data)
                nov.push({
                    'Qty':numeral(data.Novqty.toString()).format("0,0"),
                    'Value':numeral(data.Novval.toString()).format("0,0.0000")
                })
            })

            let dec = []
            monthwisehelp.map((data) => {
                // console.log(data)
                dec.push({
                    'Qty':numeral(data.Decqty.toString()).format("0,0"),
                    'Value':numeral(data.Decval.toString()).format("0,0.0000")
                })
            })

            let totalExcel = []
            monthwisehelp.map((data) => {
                // console.log(data)
                totalExcel.push({
                    'Qty':numeral(data.Totqty.toString(),).format("0,0"),
                    'Value':numeral(data.Totval.toString()).format("0,0.0000")
                })
            })

            const wb = new Xl.Workbook();
            const ws = wb.addWorksheet('Month Wise Booking'); 
            var headings = wb.createStyle({
                font: {
                    bold: true,
                    size: 12,
                    vertAlign: 'center'
                },
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true
                },
                border: {
                    left: {
                        style: "thin"
                    },
                    right: {
                        style: "thin"
                    },
                    top: {
                        style: "thin"
                    },
                    bottom: {
                        style: "thin"
                    }
                },
                fill: {
                    type: 'pattern',
                    patternType: 'solid',
                    fgColor: '#ddd9c3'
                }
            });
    
            var heading1 = wb.createStyle({
                font: {
                    bold: false,
                    size: 12,
                    vertAlign: 'center'
                },
                alignment: {
                    horizontal: 'right',
                    vertical: 'center',
                    wrapText: true
                },
                border: {
                    left: {
                        style: "thin"
                    },
                    right: {
                        style: "thin"
                    },
                    top: {
                        style: "thin"
                    },
                    bottom: {
                        style: "thin"
                    }
                }
            })

            var heading2 = wb.createStyle({
                font: {
                    bold: true,
                    size: 12,
                    vertAlign: 'center'
                },
                alignment: {
                    horizontal: 'right',
                    vertical: 'center',
                    wrapText: true
                },
                border: {
                    left: {
                        style: "thin"
                    },
                    right: {
                        style: "thin"
                    },
                    top: {
                        style: "thin"
                    },
                    bottom: {
                        style: "thin"
                    }
                },
                fill: {
                    type: 'pattern',
                    patternType: 'solid',
                    fgColor: '#ddd9c3'
                }
            });
    
            let headingColumnIndex = 2;
            let MergeHeader =1
            buyerName.forEach(heading => {
                ws.cell(7, headingColumnIndex++, 7, headingColumnIndex++, true)
                    .string(heading).style(headings)
                    ws.cell(8,MergeHeader+=1).string('Qty').style(headings)
                    ws.cell(8,MergeHeader+=1).string('Value').style(headings)
        
            });
    
            // let headingColumnIndex1 = 2;
            // qtyValue.forEach(heading => {
            //     ws.cell(8, headingColumnIndex1++)
            //         .string(heading).style(headings)
            // });

            let rowIndex1 = 9;
            let columnIndex1 = 2;
            jan.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex1).setWidth(30);
                    ws.cell(rowIndex1,columnIndex1++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex2 = 10;
            let columnIndex2 = 2;
            feb.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex2).setWidth(30);
                    ws.cell(rowIndex2,columnIndex2++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex3 = 11;
            let columnIndex3 = 2;
            mar.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex3).setWidth(30);
                    ws.cell(rowIndex3,columnIndex3++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex4 = 12;
            let columnIndex4 = 2;
            apr.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex4).setWidth(30);
                    ws.cell(rowIndex4,columnIndex4++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex5 = 13;
            let columnIndex5 = 2;
            may.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex5).setWidth(30);
                    ws.cell(rowIndex5,columnIndex5++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex6 = 14;
            let columnIndex6 = 2;
            jun.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex6).setWidth(30);
                    ws.cell(rowIndex6,columnIndex6++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex7 = 15;
            let columnIndex7 = 2;
            jul.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex7).setWidth(30);
                    ws.cell(rowIndex7,columnIndex7++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex8 = 16;
            let columnIndex8 = 2;
            aug.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex8).setWidth(30);
                    ws.cell(rowIndex8,columnIndex8++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex9 = 17;
            let columnIndex9 = 2;
            sep.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex9).setWidth(30);
                    ws.cell(rowIndex9,columnIndex9++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex10 = 18;
            let columnIndex10 = 2;
            oct.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex10).setWidth(30);
                    ws.cell(rowIndex10,columnIndex10++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex11 = 19;
            let columnIndex11 = 2;
            nov.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex11).setWidth(30);
                    ws.cell(rowIndex11,columnIndex11++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex12 = 20;
            let columnIndex12 = 2;
            dec.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex12).setWidth(30);
                    ws.cell(rowIndex12,columnIndex12++)
                        .string(record [columnName]).style(heading1)        
                });
            });

            let rowIndex13 = 21;
            let columnIndex13 = 2;
            totalExcel.forEach( record => {
                Object.keys(record ).forEach(columnName =>{
                //   console.log(record)
                ws.column(columnIndex13).setWidth(30);
                    ws.cell(rowIndex13,columnIndex13++)
                        .string(record [columnName]).style(heading2)        
                });
            });
    
            ws.cell(1, 1, 1, 15, true).string('Month Wise Booking').style(headings);

            ws.cell(7, 1, 8, 1, true).string('Months').style(headings)

            ws.cell(9, 1).string('JAN').style(headings)
            ws.cell(10, 1).string('FEB').style(headings)
            ws.cell(11, 1).string('MAR').style(headings)
            ws.cell(12, 1).string('APR').style(headings)
            ws.cell(13, 1).string('MAY').style(headings)
            ws.cell(14, 1).string('JUN').style(headings)
            ws.cell(15, 1).string('JUL').style(headings)
            ws.cell(16, 1).string('AUG').style(headings)
            ws.cell(17, 1).string('SEP').style(headings)
            ws.cell(18, 1).string('OCT').style(headings)
            ws.cell(19, 1).string('NOV').style(headings)
            ws.cell(20, 1).string('DEC').style(headings)
            ws.cell(21, 1).string('TOTAL').style(headings)
    
            ws.cell(3, 1).string('Company').style(headings);
            ws.cell(3, 2).string(Companyvalue.label).style(headings);
    
            ws.cell(3, 4).string('Buyer').style(headings);
            ws.cell(3, 5).string(buyervalue.label).style(headings);
            
            ws.cell(5, 1).string('From Date').style(headings);
            ws.cell(5, 2).string(moment(fromdate).format("DD-MM-yyyy")).style(headings);
    
            ws.cell(5, 4).string('To Date').style(headings);
            ws.cell(5, 5).string(moment(todate).format("DD-MM-yyyy")).style(headings);    
    
            wb.writeToBuffer().then(function(buffer) {
                //console.log(buffer)
                const data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
                //console.log(datas)
                FileSaver.saveAs(data,  'MonthWiseBooking' + ".xlsx")
            });
    }
    const handleDownload = async() => {
        const value =   await axios.instance.get(`/MonthWiseBooking/MonthwiseExcel?companys=${Companyvalue.label}&buyers=${buyervalue.label}&companyId=${Companyvalue.value}&buyerId=${buyervalue.value}&fromDate=${moment(fromdate).format('YYYY-MM-DD')}&toDate=${moment(todate).format('YYYY-MM-DD')}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                   // window.open(response.data, '_blank');
                
                   // const link = document.createElement('a');
                   // link.href = url;
                  //  link.setAttribute('download', 'PO_Status.xlsx');
                   // document.body.appendChild(link);
                  //  window.open(link)
                   // link.click();
     
                   
                })
               // window.open(value)
                .catch(error => {
                    console.error('Error downloading Excel file:', error);
                });
        };   
        const ExporttoExcelConsolidate = async() => {
            // await  axios.instance.get('/GetDepartmentSalarySummary', { responseType: 'blob'})
                 
             // .then((res) => {
                // const xlBlob = new Blob([res.data] ,{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'})
                // FileSaver.saveAs(xlBlob , `${fileName}.xlsx`)
           //         localStorage.setItem('pdf', pdfBlob)
           //const value = BookedOrder;
          //  var date =  new Date()
        
        
           const now = new Date();
          const year = now.getFullYear();
          const month = now.toLocaleString('default', { month: 'long' });
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const amPm = hours >= 12 ? 'PM' : 'AM';
          const date =(`${month}_${day}_${year}_${hours}_${minutes}_${amPm}`)
          await window.open(`http://103.27.85.36/ExcelFilewebmins/MonthWiseBooking_${date}.xlsx`)
       // await window.open(`http://192.168.1.2/Wbei/ExcelFile/MonthWiseBooking_${date}.xlsx`)
              // })
           }
return(
    <React.Fragment>
        <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
        <div  style={{justifyContent:'center', alignItems:'center'}}>
          <div>  
            <Backdrop  open={Spinner1} className={classes.backdrop} >
              <Spinner>
                Loading...
              </Spinner>
            </Backdrop> 
          </div>
      </div>
            <Container fluid={true}>
                <Card style={{backgroundColor:"white"}}>
                    <CardBody>
                        <Row>
                            <Col>
                                <Breadcrumb title="Report" breadcrumbItem="MonthWise Booking" />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} lg={3} md={6}>
                                <FormGroup> 
                                    <Label for='excompany'>
                                        Company
                                    </Label>         
                                    <Select  
                                        value={Companyvalue}
                                        onChange={(value)=>{
                                            console.log(value.value,"companyvalue")
                                            setCompanyvalue(value)
                                        }}
                                        options={companyhelp}
                                        menuPortalTarget={document.body} 
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={12} lg={3} md={6}>
                                <FormGroup> 
                                    <Label for='exbuyer'>
                                        Buyer
                                    </Label>         
                                    <Select
                                        menuPortalTarget={document.body} 
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        name="Buyer" 
                                        value={buyervalue}
                                        onChange={(value)=>{
                                            console.log(value.value,"buyervalue")
                                            setbuyervalue(value)
                                        }}
                                        options={buyerhelp}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  sm={12} lg={3} md={6}>
                                <FormGroup> 
                                    <Label for='exfromdate'>
                                    From Date
                                    </Label>         
                                    <Input value={fromdate} id='exfromdate' name='Date' type='date' 
                                    min={"1900-01-01"} maxLength="4" max={ "9999-12-31" }
                                    onChange={(e)=> {
                                        // if(e.target.value > (new Date("1900-01-01"))){
                                            setfromdate(e.target.value)
                                        // }
                                        
                                    
                                    }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  sm={12} lg={3} md={6}>
                                <FormGroup> 
                                    <Label for='extodate'>
                                    To Date
                                    </Label>         
                                    <Input id='extodate' value={todate}
                                    min={"1900-01-01"} maxLength="4" max={ "9999-12-31" }
                                    onChange={(e)=> {
                                        console.log(e.target.value)
                                        settodate(e.target.value)}}
                                    
                                    name='ToDate' type='date' />
                                </FormGroup>
                            </Col>
                            <Col  sm={12} lg={3} md={6} style={{marginTop:'30px'}}>
                                {/* <Button color='primary' size='md' className='mx-1' onClick={()=>tabledata()}>View</Button>
                                <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}}    className="btn btn-sm btn-primary" onClick={()=>ExporttoExcelConsolidate()}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                                 <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{tabledata()}}>View</Button>
                          <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button>
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col sm={12} lg={3} md={6}>
                                <p ><span className='text-primary'>Total Qty :</span><div>{numeral(Totqty).format("0,0")}</div></p> 
                            

                            </Col>
                            <Col sm={12} lg={3} md={6}>
                                <p><span className="text-primary" >Total Value INR : </span><div>{numeral(totalininr).format('0,0.00')}</div> </p>    
                            </Col>
                        </Row> */}
                        {/* {showTable && (
                        <TableContainer
                            columns={column}
                            data={data}
                            isGlobalFilter={true}
                            //isAddCustomer={true}
                            isAddTableBorderStrap={true}
                            //   handleInvoiceClicks={handleInvoiceClicks}
                        />
                        )}  */}
                        {/* <div className='mt-3 table-responsive'>
                            <Table className=' table table-bordered border-dark '>
                                <thead>
                                    <tr> 
                                        <th className='text-center' rowSpan={2}>Buyer</th>
                                        <th className='text-center' >Jan</th>
                                        <th className='text-center' colSpan={2}>Feb</th>
                                        <th className='text-center' colSpan={2}>Mar</th>
                                        <th className='text-center' colSpan={2}>Apr</th>
                                        <th className='text-center' colSpan={2}>May</th>
                                        <th className='text-center' colSpan={2}>Jun</th>
                                        <th className='text-center' colSpan={2}>Jul</th>
                                        <th className='text-center' colSpan={2}>Aug</th>
                                        <th className='text-center' colSpan={2}>Sep</th>
                                        <th className='text-center' colSpan={2}>Oct</th>
                                        <th className='text-center' colSpan={2}>Nov</th>
                                        <th className='text-center' colSpan={2}>Dec</th>
                                    </tr>
                                    <tr>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                        <th>Order</th>
                                        <th>Value</th>
                                    </tr>
                                    <tr>
                                         <th>Total</th>
                                         <td colSpan={2}>1</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div> */}
                        {showtable &&(
                        <div className='mt-5 table-responsive'>
                            
                            <Table className=' table table-bordered border-light table-sm' style={{cursor:'pointer',borderColor:'gray'}}>
                                <thead>
                                    <tr className=' text-nowrap' style={{backgroundColor:'#11244c',color:"white"}}>
                                        <th className='text-center' rowSpan={2} style={{paddingBottom:'25px'}}>Month</th>
                                        {monthwisehelp.map((data,index)=>(
                                            <th key={index} className='text-center' colSpan={2}>{data.Buyer} {data.Year}</th>
                                        ))}
                                        {/* <th className='text-center' colSpan={2}>Total</th> */}
                                    </tr>
                                    <tr className='text-light' style={{backgroundColor:'#11244c'}}>
                                    {monthwisehelp.map((data,index)=>(
                                        <>
                                       
                                        <th className='text-center'>Qty</th>
                                        <th className='text-center'>Value</th>
                                        </>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className='border-0'>
                                        <th className='text-center' >Jan</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Janqty == 0 ? '' : data.Janqty}</td>
                                            <td className='text-end'>{data.Janval == 0 ? '' : numeral(data.Janval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                     
                                    <tr className='border-0'>
                                        <th className='text-center' >Feb</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Febqty == 0 ? '' : data.Febqty}</td>
                                            <td className='text-end'>{data.Febval == 0 ? '' : numeral(data.Febval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Mar</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Marqty == 0 ? '' : data.Marqty}</td>
                                            <td className='text-end'>{data.Marval == 0 ? '' : numeral(data.Marval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Apr</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Aprqty == 0 ? '' : data.Aprqty}</td>
                                            <td className='text-end'>{data.Aprval == 0 ? '' : numeral(data.Aprval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >May</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Mayqty == 0 ? '' : data.Mayqty}</td>
                                            <td className='text-end'>{data.Mayval == 0 ? '' : numeral(data.Mayval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Jun</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Junqty == 0 ? '' : data.Junqty}</td>
                                            <td className='text-end'>{data.Junval == 0 ? '' : numeral(data.Junval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Jul</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Julqty == 0 ? '' : data.Julqty}</td>
                                            <td className='text-end'>{data.Julval == 0 ? '' : numeral(data.Julval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Aug</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Augqty == 0 ? '' : data.Augqty}</td>
                                            <td className='text-end'>{data.Augval == 0 ? '' : numeral(data.Augval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Sep</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Sepqty == 0 ? '' : data.Sepqty}</td>
                                            <td className='text-end'>{data.Sepval == 0 ? '' : numeral(data.Sepval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Oct</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Octqty == 0 ? '' : data.Octqty}</td>
                                            <td className='text-end'>{data.Octval == 0 ? '' : numeral(data.Octval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Nov</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Novqty == 0 ? '' : data.Novqty}</td>
                                            <td className='text-end'>{data.Novval == 0 ? '' : numeral(data.Novval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr className='border-0'>
                                        <th className='text-center' >Dec</th>
                                        {monthwisehelp.map((data,index)=>(
                                        <><td className='text-end'>{data.Decqty == 0 ? '' : data.Decqty}</td>
                                            <td className='text-end'>{data.Decval == 0 ? '' : numeral(data.Decval).format('0,0.0000')}</td>
                                        </>
                                        ))}
                                    </tr>
                                    <tr style={{backgroundColor:'#11244c'}} className='text-light'>
                                        <th className='text-center' >Total</th>
                                         {monthwisehelp.map((data,index)=>(
                                         <><th className='text-end'>{data.Totqty == 0 ? '' : data.Totqty}</th>
                                            <th className='text-end'>{data.Totval == 0 ? '' : numeral(data.Totval).format('0,0.0000')}</th>
                                         </>
                                        
                                        ))}
                                         
                                    </tr>
                                </tbody>
                            </Table>
                              
                        </div>
                        )}
                    </CardBody>
                </Card>
            </Container>
        </div>   
        { notfoundpopup ? (
        <SweetAlert
          title="No Data Found..."
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnotfoundpopup(false);
          }}
        >
        </SweetAlert>
      ):null}   

{ notfoundpopup1 ? (
        <SweetAlert
          title="Invalid Date"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnotfoundpopup1(false);
          }}
        >
        </SweetAlert>
      ):null}   
  </React.Fragment>

);
}


export default MonthWiseBooking